const abouts = [
  {
    title: "Background",
    description: "Software engineer with a computer science background and hands-on experience building real-world applications. Focused on writing clean, maintainable code and delivering practical solutions.",
  },
  {
    title: "What I like building",
    description: "I enjoy building full-stack applications that solve real-world problems, focusing on clean architecture, efficient data flow, and systems that are easy to maintain and evolve over time.",
  },
  {
    title: "What I’m improving",
    description: "I’m focused on improving end-to-end ownership, from designing scalable back-end systems to building front-end experiences that stay intuitive as complexity grows.",
  },
];

function AboutPreview() {
  return (
    <section className="section alt-section scroll-reveal" id="about">
      <div className="container">
        <div className="section-heading">
          <p className="section-tag">About</p>
          <h2>Who I am</h2>
        </div>

        <div className="about-grid">
          {abouts.map((about) => (
            <article className="about-card magnetic" key={about.title}>
              <h3>{about.title}</h3>
              <p>{about.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AboutPreview;